import {
  ChangeDetectionStrategy,
  Component,
  EmbeddedViewRef,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DrawerPortalService } from '../drawer-portal/drawer-portal.service';
import { DrawerComponent } from '../drawer.component';

@Component({
  selector: 'pxc-drawer-invoker',
  imports: [DrawerComponent],
  templateUrl: './drawer-invoker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerInvokerComponent implements OnInit, OnDestroy {
  private readonly drawerPortalService = inject(DrawerPortalService);

  @ViewChild('drawerTemplate', { static: true }) drawerTemplate: TemplateRef<unknown>;

  portalViewRef: EmbeddedViewRef<unknown>;

  ngOnInit(): void {
    this.portalViewRef = this.drawerPortalService.add(this.drawerTemplate);
  }

  ngOnDestroy(): void {
    if (this.portalViewRef) {
      this.portalViewRef.destroy();
    }
  }
}
